import { Drawer, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Header.module.css";
import logo from "assets/images/stanbic_logo.svg";
import logoIcon from "assets/images/logo-icon.png";
import alert_icon from "assets/images/alert.svg";
import arrow_down from "assets/images/arrow-down.svg";
import Aside from "../aside/Aside";
import { AiOutlineMenu } from "react-icons/ai";
import { Container } from "@mui/system";
import { UserContext } from "context/UserContext";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { FaRegUserCircle } from "react-icons/fa";
import { HiOutlineLogout } from "react-icons/hi";
import { useLogout } from "api/mutations/auth";
import AppBackdrop from "component/appBackdrop/AppBackdrop";
import Search from "./modal/search/Search";
import { RiSearchFill } from "react-icons/ri";
import { AiOutlineSearch } from "react-icons/ai";
import Notifications from "./Notifications";

function Header({ activeLink }) {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useContext(UserContext);
  const [open, setOpen] = React.useState(false);
  const [notificationsOpen, setNotificationsOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [openSearchBar, setOpenSearchBar] = useState(false);
  const notificationsRef = React.useRef(null);

  const handleToggleNotifications = () => {
    setNotificationsOpen((prevOpen) => !prevOpen);
  };

  const handleCloseNotifications = (event) => {
    if (
      notificationsRef.current &&
      notificationsRef.current.contains(event.target)
    ) {
      return;
    }
    setNotificationsOpen(false);
  };
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }
  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const handleOpenSearchBar = () => {};

  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <Link to="/dashboard">
          <img src={logo} alt="" className={styles.logo_img} />
          <img src={logoIcon} alt="" className={styles.logo_icon_img} />
        </Link>
      </div>
      <div className={styles.links}>
        <Container maxWidth="xl">
          <div className={styles.links_content}>
            <div className={styles.tab_name}>
              <Typography>{activeLink}</Typography>
            </div>
            <div
              onClick={() => {
                setOpenSearchBar(true);
              }}
              className={styles.search_circle}
            >
              <RiSearchFill className={styles.search_icon} />
            </div>
            <div
              onClick={() => {
                setOpenSearchBar(true);
              }}
              className={styles.tab_search}
            >
              <AiOutlineSearch color="#9199A8" fontSize={"20px"} />
              <Typography>Search here...</Typography>
            </div>
            <div className={styles.tab_profile}>
              <div
                ref={notificationsRef}
                onClick={handleToggleNotifications}
                className={styles.notification}
              >
                <img src={alert_icon} alt="notification" />
              </div>
              <div
                className={styles.profile}
                ref={anchorRef}
                id="composition-button"
                aria-controls={open ? "composition-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
              >
                {/* <div className={styles.profile_initials}>
                  <Typography>
                    {user?.firstName[0]} {user?.lastName[0]}
                  </Typography>
                </div> */}
                <img
                  src={
                    user?.avatar 
                  }
                  className={styles.profile_img}
                  alt=""
                />
                <div className={styles.profile_dropdown}>
                  <div className={styles.profile_details}>
                    <Typography variant="h6">{user?.firstName}</Typography>
                    {/* <Typography>Customer</Typography> */}
                  </div>
                  <img src={arrow_down} alt="" />
                </div>
              </div>
              <MenuCard
                anchorRef={anchorRef}
                handleClose={handleClose}
                open={open}
                handleListKeyDown={handleListKeyDown}
              />
            </div>
            {/* <div className={styles.language}>
              <Typography>Eng</Typography>
            </div> */}
            <div className={styles.menu} onClick={() => setIsOpen(!isOpen)}>
              <AiOutlineMenu fontSize="20px" />
            </div>
          </div>
        </Container>
      </div>

      <Drawer anchor={"right"} open={isOpen} onClose={() => setIsOpen(!isOpen)}>
        <Aside activeTab={activeLink} />
      </Drawer>
      <AppBackdrop
        openModal={openSearchBar}
        handleCloseModal={() => {
          setOpenSearchBar(false);
        }}
        children={<Search />}
      />
      <Notifications
        anchorRef={notificationsRef}
        handleClose={handleCloseNotifications}
        open={notificationsOpen}
        handleListKeyDown={handleListKeyDown}
      />
    </header>
  );
}

export default Header;

const MenuCard = ({ anchorRef, handleClose, open, handleListKeyDown }) => {
  const { logOut } = useLogout();
  return (
    <Popper
      open={open}
      anchorEl={anchorRef.current}
      role={undefined}
      placement="bottom-start"
      transition
      disablePortal
      style={{ zIndex: 3 }}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === "bottom-start" ? "left top" : "left bottom",
          }}
        >
          <Paper className={styles.menu_card}>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList
                autoFocusItem={open}
                id="composition-menu"
                aria-labelledby="composition-button"
                onKeyDown={handleListKeyDown}
              >
                <Link to={"/profile"}>
                  <MenuItem
                    className={styles.menu_card_item}
                    onClick={handleClose}
                  >
                    <FaRegUserCircle fontSize="20px" />
                    Profile
                  </MenuItem>
                </Link>
                <MenuItem className={styles.menu_card_item} onClick={logOut}>
                  <HiOutlineLogout fontSize="20px" />
                  Logout
                </MenuItem>
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};
